var _defs, _path, _path2, _circle, _path3, _circle2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.93 164.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6ad3aa;}.cls-2{fill:#ff9a83;}.cls-3{fill:#ffe079;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.48,95.39H56.22A6.17,6.17,0,0,1,50,89.22V75.52a6.17,6.17,0,0,1,6.18-6.17h99.26a6.17,6.17,0,0,1,6.17,6.17v13.7A6.17,6.17,0,0,1,155.48,95.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.16,67.49a14.82,14.82,0,0,0-3,.3,14.29,14.29,0,0,0-1.43.37,14.53,14.53,0,0,0-2.66,1.12,14.94,14.94,0,0,0-3.43,2.57,15.1,15.1,0,0,0-2.57,3.42c-.23.43-.43.86-.62,1.31a14.59,14.59,0,0,0-.87,2.79,15.15,15.15,0,0,0,0,6,14.69,14.69,0,0,0,3.18,6.56,14.82,14.82,0,0,0,4.31,3.52,15.68,15.68,0,0,0,1.66.77,15.16,15.16,0,0,0,2.43.73,14.88,14.88,0,1,0,3-29.46Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 22.16,
    cy: 124.53,
    r: 14.88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.48,137.55H56.22A6.18,6.18,0,0,1,50,131.37V117.68a6.18,6.18,0,0,1,6.18-6.18h99.26a6.18,6.18,0,0,1,6.17,6.18v13.69A6.18,6.18,0,0,1,155.48,137.55Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 22.16,
    cy: 40.21,
    r: 14.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.48,53.23H56.22A6.17,6.17,0,0,1,50,47.06V33.36a6.17,6.17,0,0,1,6.18-6.17h99.26a6.17,6.17,0,0,1,6.17,6.17v13.7A6.17,6.17,0,0,1,155.48,53.23Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.bbaa34873f3df6486843e7d318422361.svg";
export { ForwardRef as ReactComponent };